export const BASE_URL = 'https://app.nocodb.com/api/v2';
export const XC_TOKEN = 'FAvMp14FBWdmKazOXlhT5xCa05yc11LUVzUW8box';
export const TABLES = {
  AUTH: 'my1tdz5wixv1ibo',
  CHATS: 'm9e8eqf3rir1snc',
  KNOWLEDGE: 'mqt5ddovvfnptof'
};